import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { WorkbenchProvider } from '@gusto/workbench';
import AccountantsLayout from 'packages/signup/components/layouts/accountantsInviteLayout';
import TofuSurvey from 'packages/signup/components/TofuSurvey';
import { SignupProvider } from 'packages/signup/components/signupProvider';
import SignupForm from 'packages/signup/components/signupForm/index';

export default function App({
  accountingFirmName,
  accountingFirmLogoUrl,
}: {
  accountingFirmName: string;
  accountingFirmLogoUrl: string | undefined;
}) {
  return (
    <BrowserRouter basename="/partners/invite">
      <WorkbenchProvider>
        <SignupProvider submissionOrigin="custompartnerlandingpage">
          <Routes>
            <Route
              path="/"
              element={
                <AccountantsLayout
                  accountingFirmName={accountingFirmName}
                  accountingFirmLogoUrl={accountingFirmLogoUrl}
                />
              }
            >
              <Route path="/:token/sign_up_form" element={<SignupForm />} />
              <Route path="*" element={<TofuSurvey />} />
            </Route>
          </Routes>
        </SignupProvider>
      </WorkbenchProvider>
    </BrowserRouter>
  );
}
